import React from 'react';
import { Grid } from '@material-ui/core';
import Divider from '@mui/material/Divider';
import { formatDate } from 'src/helpers/date';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { renderCountryFlag } from 'src/helpers/countryFlagEvent';
import intl from 'react-intl-universal';
import Button from 'src/ui/library/Button';
import { CASE_DETAIL_URL } from 'src/constants/constants';
import DOMPurify from 'dompurify';

export class DetailsCardPres extends React.Component {
  verticalDivider = {
    borderWidth: '1.5px',
    borderColor: ' #2E2E38',
    background: '#2E2E38',
    margin: '4px',
    height: '18px !important',
  };

  countryVerticalDivider = {
    margin: '4px',
    borderWidth: '1px',
    borderColor: '#2e2e38',
    background: '#2e2e38',

    height: '14px !important',
  };

  horizontaFlatLine = {
    marginTop: '25px !important',
    marginLeft: '0px !important',
    marginRight: '0px  !important',
  };

  handleCaseDetails = () => {
    const { caseId } = this.props.caseDetail;
    window.location.href = DOMPurify.sanitize(CASE_DETAIL_URL + '/' + caseId);
  };

  render() {
    let employerHeaderData = this.props.headerData;
    let data = this.props.caseDetail;
    let name = data.isChildCase ? data.dependantFullName : data.employeeFullName;

    return (
      <React.Fragment>
        <Grid className="details-card-wrapper" container>
          {employerHeaderData ? (
            <React.Fragment>
              <Grid container>
                <Grid item md={10} direction="row" className="panel-header-container">
                  <Grid container className="user-status d-flex" md={12}>
                    <span>{name}</span>
                    {name && employerHeaderData.serviceName && <Divider sx={this.verticalDivider} orientation="vertical" />}
                    <span>{employerHeaderData.serviceName ? employerHeaderData.serviceName : ''}</span>
                    {employerHeaderData.serviceName && employerHeaderData.caseTicketId && (
                      <Divider sx={this.verticalDivider} orientation="vertical" />
                    )}
                    <span>{employerHeaderData.caseTicketId ? employerHeaderData.caseTicketId : ''} </span>
                  </Grid>

                  <Grid className="travel-status d-flex">
                    <div className="font-regular">
                      {`${intl.get('newDashboard.detailsCard.caseCountry')}`}
                      <span className="colon-spacing">:</span>
                    </div>
                    <span className="flag">
                      {renderCountryFlag(employerHeaderData.serviceCountryCode, employerHeaderData.serviceCountry)}
                    </span>
                    <span>{employerHeaderData.serviceCountry ? employerHeaderData.serviceCountry : ''}</span>
                    {employerHeaderData.serviceCountry && employerHeaderData.targetDate && ' | '}
                    <span className="border-none">
                      {employerHeaderData.targetDate
                        ? intl.get('newDashboard.detailsCard.targetDate') + ': ' + formatDate(employerHeaderData.targetDate)
                        : ''}
                    </span>
                  </Grid>
                </Grid>

                <Grid item md={2} className="text-align-end case-details-button">
                  {this.props.isCorp && (
                    <Button
                      style={{
                        marginLeft: 'auto',
                        background: 'unset',
                        width: '147px',
                        height: '40px',
                      }}
                      className="primary-btn"
                      onClick={this.handleCaseDetails}>
                      <span>{intl.get('newDashboard.detailsCard.caseDetails')}</span>
                    </Button>
                  )}
                </Grid>
              </Grid>

              <Grid item className="d-flex align-items-center">
                <Grid item xs={12}>
                  <Grid container className="local-applicant font-light font-14" lg={12} md={12}>
                    <Grid item xs={12} direction="row" className="space-traveldate d-flex">
                      <div className="d-flex">
                        <span className="font-regular">{`${intl.get('newDashboard.detailsCard.homeCountry')}`} : </span>
                        {employerHeaderData.homeCountry && (
                          <div className="flag">
                            {renderCountryFlag(employerHeaderData.homeCountryCode, employerHeaderData.homeCountry)}
                          </div>
                        )}
                        <span className={employerHeaderData.homeCountry ? '' : 'homeCountry-pdl-3'}>{`${
                          employerHeaderData.homeCountry ? employerHeaderData.homeCountry : '-'
                        } `}</span>
                      </div>

                      {employerHeaderData.travelStartDate && employerHeaderData.travelEndDate ? (
                        <div>
                          <span className="font-regular">|</span>

                          {/* <span className="font-regular">{`${intl.get('newDashboard.detailsCard.homeCountry')}`} : </span> */}

                          <div className="display-inline">
                            {employerHeaderData.travelStartDate && employerHeaderData.travelEndDate ? (
                              <div>
                                <span className="font-regular">{` ${intl.get('newDashboard.detailsCard.travelDates')} : `}</span>
                                <span>{formatDate(employerHeaderData.travelStartDate)}</span>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                          <span>
                            {employerHeaderData.travelStartDate && employerHeaderData.travelEndDate
                              ? ` ${intl.get('newDashboard.detailsCard.to')} ` + formatDate(employerHeaderData.travelEndDate)
                              : ''}
                          </span>
                        </div>
                      ) : null}

                      {/* <span>{`${intl.get('newDashboard.detailsCard.destination') +
                            ': ' +
                            (employerHeaderData.serviceCountry ? employerHeaderData.serviceCountry : '-')}`}</span> */}
                    </Grid>

                    {data.isChildCase ? (
                      <Grid item xs={12}>
                        {/* {data.isChildCase ? ( */}
                        <span>
                          <div className="contact-card-dependant">
                            <span className="font-regular">{`${intl.get('newDashboard.detailsCard.dependentOf')}`} : </span>
                            <span>{`${data.employeeFullName && data.employeeFullName}`}</span>
                            &nbsp;{' '}
                            <span className="contact-card">
                              <img src={require('../../../../assets/supervisor_account_24px.svg')} alt="Contact card" />
                            </span>
                          </div>
                        </span>
                      </Grid>
                    ) : null}
                    {employerHeaderData.isImmigration && (
                      <Grid item className="local-application-type font-light font-14" lg={12} md={12}>
                        <div>
                          <span className="font-regular">{`${intl.get('newDashboard.detailsCard.localApplicationType')}`} : </span>
                          <span>{`${employerHeaderData.localApplicationType ? employerHeaderData.localApplicationType : '-'}`}</span>
                        </div>

                        <div>
                          <span className="font-regular">{`${intl.get('newDashboard.detailsCard.localApplicationSubType')}`} : </span>
                          <span>{`${employerHeaderData.localApplicationSubType ? employerHeaderData.localApplicationSubType : '-'}`}</span>
                        </div>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                {/* <Grid item xs={12}>
                  {data.isChildCase ? (
                    <span>
                      <div className="contact-card-dependant">
                        <span>{`${intl.get('newDashboard.detailsCard.dependentOf')}: ${data.employeeFullName &&
                          data.employeeFullName}`}</span>
                        &nbsp;{' '}
                        <span className="contact-card">
                          <img src={require('../../../../assets/supervisor_account_24px.svg')} />
                        </span>
                      </div>
                    </span>
                  ) : null}
                </Grid> */}
              </Grid>
            </React.Fragment>
          ) : (
            <div style={{ margin: 'auto' }}>
              <Spinner size={30} />
            </div>
          )}

          <Grid lg={12} md={12} className="horizontal-divider">
            <Divider sx={this.horizontaFlatLine} textAlign="center" variant="middle" />
          </Grid>
        </Grid>

        {/* this code format as per old design.  */}

        {/* <Grid className="details-card-wrapper" item lg={12} md={12}>
          <Grid
            style={{
              display: 'flex',
            }}>
            <Grid className="w-100">
              {employerHeaderData ? (
                <React.Fragment>
                  <Grid
                    style={{
                      maxWidth: '100%',
                    }}
                    container
                    className="user-status"
                    lg={9}
                    md={9}>
                    <span>{name}</span>
                    {name && employerHeaderData.serviceName && <Divider sx={this.verticalDivider} orientation="vertical" />}
                    <span>{employerHeaderData.serviceName ? employerHeaderData.serviceName : ''}</span>
                    {employerHeaderData.serviceName && employerHeaderData.caseTicketId && (
                      <Divider sx={this.verticalDivider} orientation="vertical" />
                    )}
                    <span>{employerHeaderData.caseTicketId ? employerHeaderData.caseTicketId : ''} </span>
                  </Grid>
                  <Grid container className="travel-status" lg={8} md={8}>
                    <span className="flag">
                      {renderCountryFlag(employerHeaderData.serviceCountryCode, employerHeaderData.serviceCountry)}
                    </span>
                    {employerHeaderData.serviceCountry ? employerHeaderData.serviceCountry : ''}
                    {employerHeaderData.serviceCountry && employerHeaderData.targetDate && ' | '}
                    {employerHeaderData.targetDate
                      ? intl.get('newDashboard.detailsCard.targetDate') + ': ' + formatDate(employerHeaderData.targetDate)
                      : ''}
                  </Grid>

                  <Grid item xs={12} className="d-flex align-items-center">
                    <Grid item xs={8}>
                      <Grid container className="local-applicant font-light font-14" lg={12} md={12}>
                        <Grid item xs={12} direction="row" className="space-traveldate">
                          <span>{`${intl.get('newDashboard.detailsCard.homeCountry') +
                            ': ' +
                            (employerHeaderData.homeCountry ? employerHeaderData.homeCountry : '-')}`}</span>
                          <span>{`${intl.get('newDashboard.detailsCard.destination') +
                            ': ' +
                            (employerHeaderData.serviceCountry ? employerHeaderData.serviceCountry : '-')}`}</span>
                        </Grid>
                        {employerHeaderData.travelStartDate ? (
                          <Grid item xs={12} direction="row">

                            <span>
                              {employerHeaderData.travelStartDate
                                ? ` ${intl.get('newDashboard.detailsCard.travelDates')}: ` + formatDate(employerHeaderData.travelStartDate)
                                : ''}
                              {employerHeaderData.travelEndDate
                                ? ` ${intl.get('newDashboard.detailsCard.to')} ` + formatDate(employerHeaderData.travelEndDate)
                                : ''}
                            </span>
                          </Grid>
                        ) : null}
                        {employerHeaderData.isImmigration && (

                          <Grid item className="local-applicant font-light font-14" lg={12} md={12}>
                            <span>{`${intl.get('newDashboard.detailsCard.localApplicationType') +
                              ': ' +
                              (employerHeaderData.localApplicationType ? employerHeaderData.localApplicationType : '-')}`}</span>
                            <span>{`${intl.get('newDashboard.detailsCard.localApplicationSubType') +
                              ': ' +
                              (employerHeaderData.localApplicationSubType ? employerHeaderData.localApplicationSubType : '-')}`}</span>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={4}>
                      {data.isChildCase ? (
                        <span>
                          <div className="contact-card-dependant">
                            <span>{`${intl.get('newDashboard.detailsCard.dependentOf')}: ${data.employeeFullName &&
                              data.employeeFullName}`}</span>
                            &nbsp;{' '}
                            <span className="contact-card">
                              <img src={require('../../../../assets/supervisor_account_24px.svg')} />
                            </span>
                          </div>
                        </span>
                      ) : null}
                    </Grid>
                  </Grid>

                </React.Fragment>
              ) : (
                <div style={{ margin: 'auto' }}>
                  <Spinner size={30} />
                </div>
              )}
            </Grid>
            {this.props.isCorp && (
              <Button
                style={{
                  marginLeft: 'auto',
                  background: 'unset',
                  width: '147px',
                  height: '40px',
                }}
                className="primary-btn"
                onClick={this.handleCaseDetails}>
                <span>{intl.get('newDashboard.detailsCard.caseDetails')}</span>
              </Button>
            )}
          </Grid>
          <Grid lg={12} md={12}>
            <Divider sx={this.horizontaFlatLine} textAlign="center" variant="middle" />
          </Grid>
        </Grid> */}
      </React.Fragment>
    );
  }
}

export default DetailsCardPres;
